<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <div class="header">
        <h3 v-if="mobile" class="page-title col-xs-12 col-md-6 pt-2">
          Monitore agendas
        </h3>
        <toolbar
          v-if="mobile"
          class="toolbar col-xs-12 col-md-6"
          :is-mobile="mobile"
          :filter-opt="filterOpt"
          :is-filtering="isFiltering"
          @filter-by="onFilterBy"
          :type-filtering="
            tab1.toLowerCase() === 'exibir todas' ? '' : tab1.toLowerCase()
          "
          @search="searchBy"
          @clear-search="onClearSearch"
          @reset="resetProp"
          :is-searching="isSearching"
          :filters="filters"
          :types-options="optionsLeft"
          :not-exists="showErrorNotFound"
          :not-search="showErrorNotSearch"
          :filter-tag="filterBy === 100 ? true : false"
          @type-change="changeTypeMobile"
        />
      </div>

      <!-- Filtros mobile -->
      <div v-if="mobile" class="mobile-filter-bar col-xs-12">
        <b-btn size="sm" variant="outline-secondary" class="mobile-filter-toggle" @click="showMobileFilters = !showMobileFilters">
          <filter-outline-icon title="" /> Filtros
          <span v-if="mobileFilterModel.length || mobileFilterStatus !== null" class="filter-active-dot"></span>
        </b-btn>
        <b-collapse v-model="showMobileFilters">
          <div class="mobile-filter-panel">
            <div class="filter-section-label">Tipo</div>
            <b-form-checkbox-group v-model="mobileFilterModel" :options="options"
              name="mobile-tipo-filters" button-variant="info" size="sm" stacked></b-form-checkbox-group>
            <div class="filter-section-label mt-2">Status</div>
            <b-form-radio-group v-model="mobileFilterStatus" buttons button-variant="light" size="sm">
              <b-form-radio :value="null">Todas</b-form-radio>
              <b-form-radio :value="0">Prob. RF</b-form-radio>
              <b-form-radio :value="1">Expiradas</b-form-radio>
              <b-form-radio :value="2">Inativas</b-form-radio>
              <b-form-radio :value="3">Ativas</b-form-radio>
            </b-form-radio-group>
          </div>
        </b-collapse>
      </div>

      <div v-if="loading" class="col-xs-12 center-xs w-100 mt-2">
        <spinner />
        <span> Aguarde...</span>
      </div>

      <div
        v-if="showErrorNotSearch && !showErrorNotFound"
        class="EmptyRequest row center-xs w-100 p-0 mt-3"
        style="text-align: left"
      >
        <img :src="searchIcon" class="empty" />
        <span>
          Não foi possível realizar a busca,
          <b-link @click="resetSearch"> clique aqui </b-link> para voltar a
          exibir as agendas.</span
        >
      </div>

      <div
        v-if="showErrorNotFound"
        class="EmptyRequest row center-xs w-100 p-0 mt-3"
      >
        <img :src="emptyIcon" class="empty" />
        <span
          >Não há agendas para exibir. Para cadastrar uma nova,
          <router-link to="/registers/schedule">clique aqui</router-link>.</span
        >
      </div>

      <div class="container-cards" v-show="!showErrorNotSearch">
        <div
          v-for="(item, index) in orderedList"
          :key="index"
          class="space-card"
        >
          <router-link
            :to="`/monitoring/schedule/${type ? type : ''}`"
            @click.native="
              () => {
                openDetailsDialog(item);
                selectedCard = index;
              }
            "
          >
            <div
              :class="`monitCard ${setBGBody(item.VALVE)} ${
                selectedCard == index ? 'activeCard' : ''
              }`"
            >
              <!-- <div :class="`monitCard`"> -->
              <div :class="`top ${setBG(item.STATUS)}`"></div>
              <div class="d-flex justify-content-between w-100">
                <h5 class="monit-name">{{ item.NAME }}</h5>
                <div>
                  <beaker-icon
                    v-if="item.VALVE.find((valve) => valve.FERTI.length)"
                    title="Agenda com ferti"
                    class="text-success"
                  />
                  <flash-off-icon
                    v-if="Number(item.PEAK_HOUR_BLOCK)"
                    title="Pausa no horário de ponta"
                    class="text-warning"
                  />

                  <!-- <water-icon title="Há Excedente Previsto" class="water-icon-excess" /> -->
                </div>
              </div>

              <calendar-remove-icon
                v-if="
                  item.STATUS == 1 && setBGBody(item.VALVE) !== 'bg-red-body'
                "
                style="vertical-align: -3px"
                title=""
              />
              <stop-icon
                v-else-if="
                  item.STATUS == 2 && setBGBody(item.VALVE) !== 'bg-red-body'
                "
                style="vertical-align: -3px"
                title=""
              />
              <play-icon
                v-else-if="
                  item.STATUS == 3 && setBGBody(item.VALVE) !== 'bg-red-body'
                "
                style="vertical-align: -3px"
                title=""
              />
              <clock-alert-icon
                v-else-if="
                  item.STATUS == 6 && setBGBody(item.VALVE) !== 'bg-red-body'
                "
                style="vertical-align: -3px"
                title=""
              />
              <flash-off-icon
                v-else-if="
                  item.STATUS == 8 && setBGBody(item.VALVE) !== 'bg-red-body'
                "
                style="vertical-align: -3px"
                title=""
              />
              <progress-clock-icon
                v-else-if="setBGBody(item.VALVE) !== 'bg-red-body'"
                style="vertical-align: -3px"
                title=""
              />
              <span class="info" v-if="setBGBody(item.VALVE) !== 'bg-red-body'">
                {{ selectInfo(item) }}
              </span>
              <div v-show="formatStatusDir(item)" class="alert-status">
                <alert-icon title="" style="font-size: 0.9em" /><span>{{
                  formatStatusDir(item)
                }}</span>
              </div>
              <div
                class="cur-valves"
                v-if="
                  item.STATUS == 3 && setBGBody(item.VALVE) !== 'bg-red-body'
                "
              >
                {{
                  item.VALVE.length &&
                  item.VALVE.filter((e) => e.STAT)
                    .map((e) => e.NAME.trim())
                    .filter((e, i, arr) => arr.indexOf(e) === i)
                    .join(", ")
                }}
              </div>
              <div v-else-if="item.STATUS == 5" class="warn-card">
                DIA NÃO SELECIONADO
              </div>
              <div class="info" v-else-if="item.STATUS == 6">BLOQUEIO</div>
              <div class="info" v-else-if="item.STATUS == 8">
                HORÁRIO DE PONTA {{ peakHourRange(item) }}
              </div>
              <footer>
                <div id="date">{{ formatUpdate(item.UPDATE) }}</div>

                <div :class="`status ${setBG(item.STATUS)}`">
                  {{ selectInfoStatus(item.STATUS) }}
                </div>
              </footer>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="monit-helper">
      <div class="container-helper">
        <div class="header-group">
          <calendar-clock-icon title="" customHeight="20px" />
          <div class="title-monit-helper">Monitore agendas</div>
        </div>
        <toolbar
          v-if="!mobile"
          type="schedule"
          :is-mobile="mobile"
          :filter-opt="filterOpt"
          :is-filtering="isFiltering"
          @filter-by="onFilterBy"
          @search="searchBy"
          :not-exists="showErrorNotFound"
          :not-search="showErrorNotSearch"
          @clear-search="onClearSearch"
          :type-filtering="
            tab1.toLowerCase() === 'exibir todas' ? '' : tab1.toLowerCase()
          "
          :is-searching="isSearching"
        />
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>Agendas</h5>
            <span> {{ orderedList.length }}</span>
          </div>
          <!-- DROPDOWN -->
          <!-- <div class="col-xs-12 monit-alerts mt-2" id="dropdown">
            <b-dropdown
              v-if="filterBy === 100 && items.length && !showErrorNotSearch"
              :text="!tab1 ? 'EXIBIR TODAS' : tab1.toUpperCase()"
              class="col-xs-12 w-100 p-0"
              variant="info"
              :disabled="items.length == 0 || !items.length"
            >
              <b-dropdown-item @click="onClearSearch">
                EXIBIR TODAS
              </b-dropdown-item>
              <b-dropdown-item
                v-for="e in optionsLeft"
                :key="e.ID"
                @click="() => selectDropdownItem(e.PATH.toLowerCase())"
                >{{ e.TYPE }}
              </b-dropdown-item>
            </b-dropdown>
            <b-button
              v-else
              variant="info"
              class="col-xs-12"
              @click="resetSearch"
              id="goBACK"
              adjust
              >EXIBIR TODAS
            </b-button>
          </div> -->

          <div class="filter-section p-2" v-if="!mobile">
            <div class="filter-section-label">Filtrar por tipo</div>
            <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="selectedCheckbox"
              :options="options"
              name="filters"
              button-variant="info"
              size="sm"
              stacked
            ></b-form-checkbox-group>
          </div>

          <div class="filter-section p-2" v-if="!mobile">
            <div class="filter-section-label">Filtrar por status</div>
            <b-form-radio-group v-model="selectedRadiusButton" buttons button-variant="light" size="sm" stacked>
              <b-form-radio :value="null">Exibir todas</b-form-radio>
              <b-form-radio :value="0">Prob. comunicação ({{ alerts[0].length }})</b-form-radio>
              <b-form-radio :value="1">Expiradas ({{ alerts[1].length }})</b-form-radio>
              <b-form-radio :value="2">Inativas ({{ alerts[2].length }})</b-form-radio>
              <b-form-radio :value="3">Ativas ({{ alerts[3].length }})</b-form-radio>
            </b-form-radio-group>
          </div>

          <!-- <div class="monit-alerts" v-for="f in filters" :key="f.value">
            <div class="monit-alert">
              <div
                @click="showErrorNotFound ? () => {} : onFilterBy(f)"
                :class="`alert-length ${setBG(f.value)}`"
              >
                <div class="group-info-card">
                  <div class="qtd-items">{{ alerts[f.value].length }}</div>
                  <p>{{ f.text }}</p>
                </div>
                <arrow-top-right class="icon" />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <schedule-details
      :item="selected"
      :agn-start="selected.START_TIME"
      :status-color="variant"
      :updated="updated"
      :variant="variant"
      :show-details="showDetails"
      :ending="endingPrediction(selected.START_TIME, selected.DURATION)"
      @close-details="closeDetails"
    />
  </div>
</template>

<script>
import { updateFormatter, organizer } from "@/pages/components/helpers";
import EventBus from "@/pages/components/eventBus";
import { monit } from "@/api";
export default {
  name: "monit-schedule",
  props: {
    mobile: Boolean,
  },
  data() {
    return {
      showDetails: false,
      showMobileFilters: false,
      mobileFilterModel: [],
      mobileFilterStatus: null,
      backendNow: null,
      selectedCard: null,
      loading: true,
      selected: {},
      filterBy: 100,
      missingResults: false,
      isSearching: false,
      isFiltering: false,
      filter: "",
      tab1: "",
      tab2: "",
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      type: null,
      optionsLeft: [
        { ID: 1, TYPE: "COM SENSORES", PATH: "SENSORS" },
        { ID: 2, TYPE: "SEM SENSORES", PATH: "NO_SENSORS" },
      ],
      options: [
        { text: "COM FERTI", value: "FERTI" },
        { text: "SEM FERTI", value: "NO_FERTI" },
      ],
      fullList: [],
      filterOpt: "",
      filters: [
        { value: 3, text: "Ativas" },
        { value: 2, text: "Inativas" },
        { value: 1, text: "Expiradas" },
        { value: 0, text: "Problemas de comunicação" },
      ],
      items: [],
      controller: null,
      timeout: null,
      alerts: {
        0: [],
        1: [],
        2: [],
        3: [],
      },
      regexSensor: null,
      showErrorNotFound: false,
      showErrorNotSearch: false,
      selectedCheckbox: [],
      selectedRadiusButton: "",
      schedules: [],
      // rf: [],
      // expireds: [],
      // inactives: [],
      // actives: []
    };
  },
  created() {
    this.$emit(
      "title-change",
      this.mobile ? "M. de Agendas" : "Monitoramento de Agendas"
    );
    this.selectedRadiusButton = null;
    this.controller = new AbortController();
    this.monitLoop();
    this.regexSensor = new RegExp("Sensor");
    if (!this.type) {
      this.tab1 = "EXIBIR TODAS";
    }
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    selectedCheckbox(newValue) {
      if (!this.mobile) {
        // this.resetDropdown();
        // this.clearSearchInput();
        // EventBus.cleanInputSearch();
        // this.filter = "";
        this.isActive(this.items);
      }
    },
    selectedRadiusButton(v) {
      if (v != null) {
        this.onFilterBy(v);
      } else {
        // this.isSearching = false;
        this.showErrorNotSearch = false;
        this.onFilterBy(100);
        // EventBus.cleanInputSearch();
      }
    },
    mobile(newValue, oldValue) {
      if (newValue) {
        this.showErrorNotSearch = false;
        this.showErrorNotFound = false;
        this.selectedRadiusButton = null;
        this.isSearching = false;
        this.selectedCheckbox = [];
        this.filter = "";
        this.showMobileFilters = false;
        this.mobileFilterModel = [];
        this.mobileFilterStatus = null;
      } else {
        this.resetSearch();
      }
    },
    schedules: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.length < oldValue.length) {
          this.fullList = oldValue;
          if (this.isSearching && this.validFilter && newValue.length) {
            this.items = this.isSearch(oldValue);
          } else {
            this.items = oldValue;
          }
        } else {
          this.fullList = newValue;
          if (this.isSearching && this.validFilter && newValue.length) {
            this.items = this.isSearch(newValue);
          } else {
            this.items = newValue;
          }
        }
      },
    },
  },
  methods: {
    closeDetails() {
      this.showDetails = false;
      this.selected = {};
      this.selectedCard = null;
    },
    formatStatusDir(item) {
      let status = this.checkStatusDir(item).map((e) => e);
      switch (status.length) {
        case 0:
          return null;
        case 1:
          return ` O DIR ${status[0]} está sem comunicar.`;
        case 2:
          if (status[0] === status[1]) {
            return ` O DIR ${status[0]} está sem comunicar.`;
          }
          return ` Os DIRs ${status[0]} e ${status[1]} estão sem comunicar.`;
        default:
          return ` Há ${status.length} DIRs sem comunicar.`;
      }
    },
    checkStatusDir(item) {
      let check = item;
      let status = [];
      if (check.VALVE && check.LEVEL.TOTAL) {
        let valves = check.VALVE;
        let lenOfLevels = check.LEVEL.TOTAL;
        let byLevels = [];
        for (let i = 1; i <= lenOfLevels; i++) {
          byLevels.push(valves.filter((valve) => valve.LEVEL == i));
        }
        check.BYLEVEL = byLevels;
        check.BYLEVEL.forEach((e) => {
          e.forEach((x) => {
            if (x.STATUS_RF) {
              let noRepeat = status.filter((e) => e !== x.DIR);
              noRepeat.push(x.DIR);
              status = noRepeat;
            }
          });
        });
      }
      if (status) {
        return status;
      } else {
        return [];
      }
    },
    resetSearch() {
      this.selectedCheckbox = [];
      this.selectedRadiusButton = null;
      this.showMobileFilters = false;
      this.mobileFilterModel = [];
      this.mobileFilterStatus = null;
      EventBus.cleanInputSearch();
      this.filter = "";
      // this.resetDropdown();
      this.isSearching = false;
      this.items = this.fullList;
      this.showErrorNotSearch = false;
      this.resetProp();
      this.resetDropdown();
      this.clearSearchInput();
    },
    onClearSearch() {
      this.filter = "";
      this.resetDropdown();
      // this.onFilterBy(100);
    },
    selectDropdownItem(option) {
      this.type = option;
      this.clearSearchInput();
    },
    changeTypeMobile(t) {
      this.type = t;
    },
    resetDropdown() {
      this.type = null;
      this.tab1 = "EXIBIR TODAS";
      this.title = "ALL";
      this.isSearching = false;
      // this.filter=""
      this.showErrorNotSearch = false;
      this.items = this.fullList;
    },
    resetProp() {
      this.onFilterBy(100);
    },
    organizeAgns(list) {
      return new Promise((resolve) => {
        let result = [];
        let numberOfAgns = list.length;
        if (!numberOfAgns) resolve(list);
        for (let i = 0; i < numberOfAgns; i++) {
          this.organizeValve(list[i])
            .then((ret) => this.organizeLevel(ret))
            .then((ret) => this.organizeActiveDays(ret))
            .then((ret) => {
              if (result.push(ret) == list.length) {
                resolve(result);
              }
            });
        }
      });
    },
    organizerPromisified(arr, key) {
      return new Promise((resolve) => resolve(organizer(arr, key)));
    },
    organizeFerti(valveIndexes, allValvesDetails, oneValveDetail) {
      return new Promise((resolve) => {
        resolve(
          organizer(
            valveIndexes
              .map((e) => {
                if (
                  allValvesDetails[e][5] == oneValveDetail[5] && //mesmo nível
                  allValvesDetails[e][6] && //se tem nível de ferti > 0
                  allValvesDetails[e][7] == oneValveDetail[2]
                )
                  //se a referência é igual ao ID dessa válvula
                  return {
                    STATUS_RF: allValvesDetails[e][1],
                    ID: allValvesDetails[e][2],
                    NAME: allValvesDetails[e][3],
                    STAT: allValvesDetails[e][4],
                    LEVEL: oneValveDetail[5],
                    FERTILEVEL: allValvesDetails[e][6],
                    CURRENT_TIME: allValvesDetails[e][8],
                    TOTAL_TIME: allValvesDetails[e][9],
                    CURRENT_VOLUME: allValvesDetails[e][10],
                    TOTAL_VOLUME: allValvesDetails[e][11],
                  };
              })
              .filter((e) => !!e),
            "FERTILEVEL"
          )
        );
      });
    },
    organizeValve(obj) {
      return new Promise(async (resolve) => {
        let result = [];
        try {
          let allValvesDetails = obj.VALVE;
          let valveIndexes = Object.keys(obj.VALVE);
          let flagRFproblem = false;
          for (let k = 0; k < valveIndexes.length; k++) {
            let key = valveIndexes[k];
            let oneValveDetail = allValvesDetails[key];
            if (oneValveDetail[1] != 0) flagRFproblem = true;
            if (!oneValveDetail[6] && !parseInt(oneValveDetail[7]))
              //só monta o objeto se não for ferti
              result.push({
                DIR: oneValveDetail[0],
                STATUS_RF: oneValveDetail[1],
                ID: oneValveDetail[2],
                NAME: oneValveDetail[3],
                STAT: oneValveDetail[4],
                LEVEL: oneValveDetail[5],
                FERTI: await this.organizeFerti(
                  valveIndexes,
                  allValvesDetails,
                  oneValveDetail
                ),
                CURRENT_TIME: oneValveDetail[8],
                TOTAL_TIME: oneValveDetail[9],
                CURRENT_VOLUME: oneValveDetail[10],
                TOTAL_VOLUME: oneValveDetail[11],
              });
          }
          if (flagRFproblem) {
            obj.RF_WARMING = 1;
          } else {
            obj.RF_WARMING = 0;
          }
          obj.VALVE = result;
          return resolve(obj);
        } catch (e) {
          console.error(e);
          resolve(obj);
        }
      });
    },
    organizeLevel(obj) {
      return new Promise((resolve) => {
        try {
          let arr = obj.LEVEL;
          obj.LEVEL = {
            CURRENT: arr[0],
            TOTAL: arr[1],
          };
          resolve(obj);
        } catch (e) {
          console.error(e);
          resolve(obj);
        }
      });
    },
    organizeActiveDays(obj) {
      return new Promise((resolve) => {
        let arr = obj.WDAY;
        try {
          obj.WDAY = {
            SUNDAY: arr[0],
            MONDAY: arr[1],
            TUESDAY: arr[2],
            WEDNESDAY: arr[3],
            THURSDAY: arr[4],
            FRIDAY: arr[5],
            SATURDAY: arr[6],
          };
          resolve(obj);
        } catch (e) {
          console.error(e);
          resolve(obj);
        }
      });
    },
    monitLoop() {
      monit
        .schedule(this.controller)
        .then((res) => {
          this.backendNow = Date.parse(res.headers.get("date"));
          return res.json();
        })
        .then((ret) => {
          return this.organizeAgns(ret);
        })
        .then((ret) => {
          let list = organizer(ret, "NAME");
          //Variável que irá ser só observada
          this.schedules = list;

          if (this.loading) this.loading = false;
          if (Object.keys(this.selected).length && this.selected.ID) {
            this.selected =
              this.items.filter((e) => e.ID == this.selected.ID)[0] ||
              this.selected;
          }
          return;
        })
        .then((_) => {
          if (!this.loading && !this.items.length && !this.showErrorNotSearch) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitLoop, 2000);
          }
        })
        .catch((err) => {
          console.error(err);
          return err.name;
        });
    },
    isActive(result) {
      let schedules = [];
      if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        this.selectedCheckbox.length > 0
      ) {
        this.isFiltering = false;
        schedules = this.isSearchSensors(result);
        if (result.length) {
        }
      } else if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        !this.selectedCheckbox.length
      ) {
        // this.tab1 = "EXIBIR TODAS";
        // this.title = "ALL";
        this.isFiltering = false;
        schedules = this.fullList;
      } else if (!this.mobile) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        // this.tab1 = "EXIBIR TODAS";
        // this.title = "ALL";
        this.isFiltering = false;
        schedules = this.fullList;
      } else if (this.mobile && !this.type) {
        this.tab1 = "EXIBIR TODAS";
        this.showErrorNotSearch = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.clearSearch();
        // this.onFilterBy(100);
        this.isFiltering = false;
        schedules = this.fullList;
        // this.items = this.fullList;
      } else if (this.mobile && this.type === "no_sensors") {
        this.tab1 = "SEM SENSORES";
        this.clearSearch();
        schedules = this.isSearchNoSensors(result);
        if (result.length) {
        }
      } else if (this.mobile && this.type === "sensors") {
        this.tab1 = "COM SENSORES";
        this.clearSearch();
        schedules = this.isSearchSensors(result);
        if (result.length) {
        }
      }
      return schedules;
    },
    isSearch(result) {
      let filter;
      filter = result.filter((item) => item.NAME.indexOf(this.filter) > -1);
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchSensors(result) {
      if (this.mobile) {
        let filter;
        filter = result.filter((item) => item.GENERIC);
        if (filter.length) {
          this.showErrorNotSearch = false;
          return filter;
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      } else {
        let results = [];
        for (let checkbox of this.selectedCheckbox) {
          let filter = [];
          if (checkbox === "FERTI") {
            filter = result.filter((item) => {
              let ferti = [];
              ferti = item.VALVE.filter((valve) => {
                if (valve.FERTI.length > 0) {
                  return true;
                }
                return false;
              });
              return ferti.length ? true : false;
            });
            // filter = result.filter((item) => item.GENERIC);
            results.push(...filter);
          } else {
            filter = result.filter((item) => {
              let ferti = [];
              ferti = item.VALVE.filter((valve) => {
                if (!valve.FERTI.length) {
                  return true;
                }
                return false;
              });
              return ferti.length ? true : false;
            });
            results.push(...filter);
          }
        }
        if (results.length) {
          this.showErrorNotSearch = false;
          return results;
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      }
    },
    isSearchNoSensors(result) {
      let filter;
      filter = result.filter((item) => !item.GENERIC);
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    formatUpdate(update) {
      return updateFormatter(update);
    },
    setBG(status) {
      if (Array.isArray(status)) {
        let valves = status;
        if (valves.length && valves.filter((e) => e.STATUS_RF != 0).length)
          return "bg-red";
        else return "bg-3v3";
      } else {
        switch (status) {
          case 0:
            return "bg-rf"; //para visão geral
          case 1:
            return "bg-grey"; //expirada
          case 3:
            return "bg-3v3";
          default:
            return "bg-black";
        }
      }
    },
    setBGBody(status) {
      if (Array.isArray(status)) {
        let valves = status;
        if (valves.length && valves.filter((e) => e.STATUS_RF != 0).length)
          return "bg-red-body";
        else return "";
      } else {
        switch (status) {
          case 0:
            return ""; //para visão geral
          case 1:
            return ""; //expirada
          case 3:
            return "";
          default:
            return "bg-black-body";
        }
      }
    },
    searchBy(name) {
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
    },
    clearSearchInput() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.items = this.fullList;
    },
    clearSearch() {
      this.showErrorNotSearch = false;
    },
    onFilterBy(value) {
      // if (value == 100) this.clearSearch();
      this.isFiltering = value != 100;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
    parseMinToHHmm(min) {
      let hours = Math.floor(min / 60);
      min = min % 60;
      return ("0" + hours).slice(-2) + ":" + ("0" + min).slice(-2);
    },
    endingPrediction(start, duration) {
      if (start && duration) {
        let startTime = start.split(":");
        let startHourInMin = parseInt(startTime[0]) * 60;
        let startTimeInMin = startHourInMin + parseInt(startTime[1]);
        let sum = startTimeInMin + duration;
        if (sum > 24 * 60)
          // one day = 1440 minutes
          sum = sum % (24 * 60);
        return this.parseMinToHHmm(sum);
      }
    },
    selectInfo(item) {
      let info = [];
      let stat = item.STATUS;
      if (stat != 1) {
        let duration = item.DURATION;
        let start = item.START_TIME;
        start = start.split(":");
        start = start[0] + ":" + start[1];
        info = `${start} - ${this.endingPrediction(
          item.START_TIME,
          item.DURATION
        )}`;
      } else info = "EXPIRADA";
      return info;
    },
    // fw_cir#212: a faixa vem pronta no GENERIC, igual à agenda do PIR.
    peakHourRange(item) {
      const g = (item.GENERIC || []).find((x) => x.NAME && x.NAME.trim() === "Horário de ponta:");
      return g ? `(${g.VALUE})` : "";
    },
    selectInfoStatus(status) {
      if (Array.isArray(status)) {
        let valves = status;
        if (valves.length && valves.filter((e) => e.STATUS_RF != 0).length)
          return "bg-red";
        else return "ATIVA";
      } else {
        switch (status) {
          case 0:
            return "bg-rf"; //para visão geral
          case 1:
            return "EXPIRADA"; //expirada
          case 3:
            return "ATIVA";
          case 8:
            return "PAUSADA";
          default:
            return "INATIVA";
        }
      }
    },
    setRemainingTime(d, e) {
      let remainigMin = d - e;
      let difInSec = remainigMin * 60;
      let difInDays = Math.floor(difInSec / 86400);
      let difInH = Math.floor((difInSec % 86400) / 3600);
      let difInMin = Math.floor(((difInSec % 86400) % 3600) / 60);
      let result = ("0" + difInH).slice(-2) + ":" + ("0" + difInMin).slice(-2);
      return result;
    },
  },
  computed: {
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    variant() {
      return Object.keys(this.selected).length
        ? this.setBG(this.selected.STATUS).split("-")[1]
        : "bg-grey";
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    orderedList() {
      let filter = this.filterBy;
      let result = this.items;

      if (result.length && this.type && this.type == "no_sensors") {
        result = this.isActive(result);
      } else if (
        result.length &&
        this.type &&
        this.type == "sensors" &&
        !this.selected.ID
      ) {
        result = this.isActive(result);
      }

      if (result.length > 0) {
        result = this.isActive(result);
      }

      this.alerts[0] = result.filter(
        (item) => this.setBG(item.VALVE) == "bg-red"
      );
      this.alerts[1] = result.filter((item) => item.STATUS == 1);
      this.alerts[2] = result.filter(
        (item) => item.STATUS != 3 && item.STATUS != 1
      );
      this.alerts[3] = result.filter((item) => item.STATUS == 3);

      if (
        this.isSearching &&
        this.validFilter &&
        result.length &&
        this.selectedRadiusButton == null
      ) {
        result = this.isSearch(result);
        this.alerts[0] = result.filter(
          (item) => this.setBG(item.VALVE) == "bg-red"
        );
        this.alerts[1] = result.filter((item) => item.STATUS == 1);
        this.alerts[2] = result.filter(
          (item) => item.STATUS != 3 && item.STATUS != 1
        );
        this.alerts[3] = result.filter((item) => item.STATUS == 3);
      }

      if (
        this.isSearching &&
        this.validFilter &&
        this.selectedRadiusButton !== null
      ) {
        result = this.isSearch(result);
        this.alerts[0] = result.filter(
          (item) => this.setBG(item.VALVE) == "bg-red"
        );
        this.alerts[1] = result.filter((item) => item.STATUS == 1);
        this.alerts[2] = result.filter(
          (item) => item.STATUS != 3 && item.STATUS != 1
        );
        this.alerts[3] = result.filter((item) => item.STATUS == 3);
        if (filter != 100) {
          if (this.mobile) {
            result = this.alerts[filter.value];
            try {
              if (!result.length) {
                this.showErrorNotSearch = true;
              } else {
                this.showErrorNotSearch = false;
              }
            } catch (error) {
              console.error(error);
            }
          } else {
            result = this.isSearch(this.alerts[filter]);
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          }
        }
      } else if (filter != 100) {
        if (this.mobile) {
          result = this.alerts[filter.value];
          try {
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          result = this.isSearch(this.alerts[filter]);
          if (!result.length) {
            this.showErrorNotSearch = true;
          } else {
            this.showErrorNotSearch = false;
          }
        }
      }
      if (this.mobile) {
        if (this.mobileFilterModel.length > 0) {
          result = result.filter(item => {
            for (const val of this.mobileFilterModel) {
              if (val === 'FERTI' && item.VALVE.some(v => v.FERTI.length > 0)) return true;
              if (val === 'NO_FERTI' && !item.VALVE.some(v => v.FERTI.length > 0)) return true;
            }
            return false;
          });
        }
        if (this.mobileFilterStatus !== null) {
          switch (this.mobileFilterStatus) {
            case 0: result = result.filter(item => this.setBG(item.VALVE) === 'bg-red'); break;
            case 1: result = result.filter(item => item.STATUS === 1); break;
            case 2: result = result.filter(item => item.STATUS !== 3 && item.STATUS !== 1); break;
            case 3: result = result.filter(item => item.STATUS === 3); break;
          }
        }
      }

      return result;
    },
  },
};
</script>

<style scoped>
.cur-valves {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
